import { Injectable, EventEmitter } from '@angular/core';
// import { HttpClient } from './http-client';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

// import { User } from './user.modal';

import { GlobalConstants } from './global-variables';
import { BrowserStorageService } from './browser-storage.service';

export type User = {
  id: number;
  token?: string;
  mobile?: any;
}

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
  public currentUserSubject: BehaviorSubject<User|any>;
  public currentUser: Observable<User>;
  public errorEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  public reloadInit: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isUserAuthenticated:any;
  constructor(private http: HttpClient, public GlobalConstants: GlobalConstants,
    private localStore: BrowserStorageService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(this.localStore.get('currentUser')));
    this.isUserAuthenticated = JSON.parse(this.localStore.get('currentUser'));
    this.currentUser = this.currentUserSubject.asObservable();
    if (this.GlobalConstants && this.GlobalConstants.data && this.GlobalConstants.data.api_version == 'v2') {
      environment.corePath = environment.corePathV2;
      environment.offerPath = environment.offerPathV2;
      
    }
  }

  public get currentUserValue(): any {
    return this.http.get<any>(environment.corePath + '/user').pipe(
    map(res => {
      return res;
    }),
      catchError((err: HttpErrorResponse) => {
        return throwError(() => err);
      }));
  }

  getCurrentUser(bin: any, bin_type: any) {
    return this.http.get<any>(environment.corePath + '/user').pipe(
      map(res => res || []),
      catchError(error => throwError(error))
    );
  }
  login(email: string, password: string) {
    return this.http.post<any>(environment.corePath + '/sessions', { email, password })
      .pipe(
        map(res => {
          let user = {
            subdomain: res.data.relationships.target.links.subdomain,
            token: res.data.attributes.token
          }
          // login successful if there's a jwt token in the response
          if (user && user.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            this.isUserAuthenticated = user;
            this.localStore.set('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(res);
          }

          return user;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
  }

  validateExistingUser(mobile: string, bin = '') {
    if (bin == '') {
      return this.http.post<any>(environment.corePath + '/users/search', { mobile })
        .pipe(
          map(res => {
            return res;
          }),
          catchError((err: HttpErrorResponse) => {
            return throwError(() => err);
          })
        );
    }
    else {
      return this.http.post<any>(environment.corePath + '/users/search', { mobile, bin })
        .pipe(
          map(res => {
            return res;
          }),
          catchError((err: HttpErrorResponse) => {
            return throwError(() => err);
          })
        );
    }
  }


  createUser(mobile: string, email: string, country_id: string = "default") {
    if (country_id == 'default') {
      return this.http.post<any>(environment.corePath + '/users', { mobile: mobile, email: email })
        .pipe(
          map(res => {
            return res;
          }),
          catchError((err: HttpErrorResponse) => {
            return throwError(() => err);
          })
        );
    }
    else {

      return this.http.post<any>(environment.corePath + '/users', { mobile: mobile, email: email, country_id: country_id })
        .pipe(
          map(res => {
            return res;
          }),
          catchError((err: HttpErrorResponse) => {
            return throwError(() => err);
          })
        );
    }

  }

  requestUserOtp(mobile: string, userId: string) {
    return this.http.post<any>(environment.corePath + '/users/' + userId + '/otps', { mobile: mobile, otp_type: "login" })
      .pipe(
        map(res => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
  }

  validateUserOtp(userId: string, otp: string, otpType: string, mobileNum?: any) {
    return this.http.post<any>(environment.corePath + '/users/' + userId + '/otps/verify', { otp_type: otpType, code: otp })
      .pipe(
        map(res => {
          let user: any = {
            id: userId,
            token: res.token
          }
          if (mobileNum) {
            user['mobile'] = mobileNum;
          }
          if (user && user.token) {
            this.localStore.set('currentUser', JSON.stringify(user));
            this.isUserAuthenticated = user;
            this.currentUserSubject.next(res);
          }

          return user;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
  }

  authenticateConcierge(password: string) {
    return this.http.post<any>(environment.corePath + '/sessions/concierge_login', { password: password })
      .pipe(
        map(res => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
  }

  validateExistingUserThroughConcierge(mobile: string, password: string) {
    return this.http.post<any>(environment.corePath + '/users/search', { mobile, password })
      .pipe(
        map(res => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
  }

  externalRequestUserOtp(mobile: string) {
    return this.http.post<any>(environment.corePath + '/external_otps', { mobile: mobile })
      .pipe(
        map(res => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
  }

  externalValidateUserOtp(otp: string, ref_no: string, mobileNum?: any) {
    return this.http.post<any>(environment.corePath + '/external_otps/verify', { ref_no: ref_no, code: otp })
      .pipe(
        map(res => {
          let user: User = {
            id: res.id,
            token: res.token
          }
          if (mobileNum) {
            user['mobile'] = mobileNum;
          }
          if (user && user.token) {
            this.localStore.set('currentUser', JSON.stringify(user));
            this.isUserAuthenticated = user;
            this.currentUserSubject.next(res);
          }

          return user;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
  }

  logout() {
    this.localStore.remove('points', 'session');
    this.localStore.remove('client', 'session');
    const offerToRedeem = this.localStore.get('offerToRedeem');
    const firstLoad = this.localStore.get('firstLoad');
    const returnUrl = this.localStore.get("returnUrl");
    this.localStore.clear();
    if (offerToRedeem) {
      this.localStore.set("offerToRedeem", offerToRedeem);
    }
    if (firstLoad) {
      this.localStore.set("firstLoad", firstLoad);
    }
    // storing beta key before clear session storage
    const beta = this.localStore.get("beta", 'session');
    const betaCredit = this.localStore.get("betaCredit", 'session');

    this.localStore.clear('session');
    if (beta) {
      this.localStore.set("beta", beta, 'session');
    }
    if (betaCredit) {
      this.localStore.set("betaCredit", betaCredit, 'session');
    }
    if (returnUrl) {
      this.localStore.set("returnUrl", returnUrl);
    }
    this.isUserAuthenticated = '';
    this.currentUserSubject.next(null);
  }

  deleteToken() {
    let currentUserId = '';
    if (JSON.parse(this.localStore.get('currentUser'))) {
      currentUserId = JSON.parse(this.localStore.get('currentUser')).id
    }
    return this.http.post<any>(environment.corePath + '/sessions/' + currentUserId, {})
      .pipe(
        map(res => {
          return res;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(() => err);
        })
      );
  }
}
